import { constants } from '@bedc/constants';
import { iotsUtils } from '@bedc/core';

export const AdminColumnField = iotsUtils.fromList(constants.client.search.adminColumnFields);

export const ColumnField = iotsUtils.fromList(constants.client.search.columnFields);
